import { defaultStyles } from '@visx/tooltip'
import moment from 'moment'
import { avatarColors, shadows } from 'transfix-ui/theme'
import { brandColors } from 'transfix-ui/theme/colors'

export const POINT_RADIUS = 4
export const POINT_DIAMETER = 8

export const BAR_COLORS = [
  brandColors.skyBlue6,
  avatarColors.plumPurple,
  avatarColors.roseRed,
  avatarColors.orange,
  avatarColors.artichokeGreen,
  avatarColors.iceBlue,
  avatarColors.lavenderPurple,
  avatarColors.bubblegumPink,
  avatarColors.salmonRed,
  avatarColors.spruceGreen,
  avatarColors.steelBlue,
]

export const SINGLE_BAR_COLOR = brandColors.skyBlue6

const AXIS_LABEL_FONT_SIZE = 10

export const STYLE_PRESETS = {
  axisColor: brandColors.coolGray5,
  minHeight: 270,
  axisLabelFontSize: AXIS_LABEL_FONT_SIZE,
  /**
   * calculate the lineHeight to know how to calculate the chart boundaries.
   */
  axisLabelLineHeight: AXIS_LABEL_FONT_SIZE * 1.4,
  /**
   * calculate the offset to center it vertically respective to its size.
   * NOTE: this is an absolute value and the sign (+/-) can be changed as needed.
   */
  axisLabelYOffset: AXIS_LABEL_FONT_SIZE / 2,
  axisLabelFontWeight: 600,
  scaleBandPadding: 0.2,
}

export const TOOLTIP_STYLE = {
  ...defaultStyles,
  boxShadow: shadows[10],
  color: brandColors.coolGray8,
  padding: 0,
}

/**
 * Fake data populates the loading state
 * for the `loadingTickComponent`
 */
const dateNow = moment().format('MM/DD')
const dateMid = moment().subtract(30, 'days').format('MM/DD')
const dateEnd = moment().subtract(60, 'days').format('MM/DD')
export const LOADING_DATA = {
  xdomain: [dateNow, dateMid, dateEnd],
  ydomain: 50,
  swidth: 26,
  sheight: 15,
}
